import { render, staticRenderFns } from "./BookingProducts.vue?vue&type=template&id=5b9663a0&"
import script from "./BookingProducts.vue?vue&type=script&lang=js&"
export * from "./BookingProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports